module.exports = __webpack_public_path__ + "static/img/multiplierIcon.57e6ec81.png";